import { NavLink } from "react-router-dom";

const MenuBottom = () => {
  const listMenu = [
    {
      name: "Trang chủ",
      path: "/",
      icon: <i className="fa-solid fa-house"></i>,
    },
    {
      name: "Xu hướng",
      path: "/history",
      icon: <i className="fa-solid fa-square-poll-vertical"></i>,
    },
    {
      name: "Cá nhân",
      path: "/account",
      icon: <i className="fa-solid fa-user"></i>,
    },
    {
      name: "CSKH",
      path: "/message",
      icon: <i className="fa-solid fa-headset"></i>,
    },
  ];
  return (
    <div className="menu-bottom d-flex justify-content-between align-items-center">
      {listMenu.map((item) => (
        <NavLink
          key={item.name}
          to={item.path}
          className="text-center w-100 d-flex flex-column justify-content-center align-items-center"
        >
          <div className="text-white">{item.icon}</div>
          <span className="text-white">{item.name}</span>
        </NavLink>
      ))}
      {/* <NavLink
        to={"/"}
        className="text-center w-100 d-flex flex-column justyfy-content-center align-items-center"
      >
        <HomeIcon style={{ fill: "#fff" }} width={20} />
        <span>Trang chủ</span>
      </NavLink>
      <NavLink
        to={"/history"}
        className="text-center w-100 d-flex flex-column justyfy-content-center align-items-center"
      >
        <HeThongIcon style={{ fill: "#fff" }} />
        <span>Xu hướng</span>
      </NavLink>
      <NavLink
        to={"/account"}
        className="text-center w-100 d-flex flex-column justyfy-content-center align-items-center"
      >
        <AccountIcon style={{ fill: "#fff" }} />
        <span>Trang cá nhân</span>
      </NavLink>
      <NavLink
        to={"/message"}
        className="text-center w-100 d-flex flex-column justyfy-content-center align-items-center"
      >
        <CskhIcon style={{ fill: "#fff" }} />
        <span>CSKH</span>
      </NavLink> */}
    </div>
  );
};

export default MenuBottom;
